import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconMoreVertLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 19.27c-.412 0-.766-.148-1.06-.442a1.444 1.444 0 0 1-.44-1.059c0-.412.147-.765.44-1.06a1.45 1.45 0 0 1 1.06-.44c.412 0 .766.147 1.06.44.293.294.44.648.44 1.06 0 .413-.147.766-.44 1.06a1.45 1.45 0 0 1-1.06.44Zm0-5.77a1.45 1.45 0 0 1-1.06-.44A1.444 1.444 0 0 1 10.5 12c0-.412.147-.766.44-1.06A1.45 1.45 0 0 1 12 10.5c.412 0 .766.147 1.06.44.293.294.44.648.44 1.06 0 .412-.147.765-.44 1.06a1.45 1.45 0 0 1-1.06.44Zm0-5.77c-.412 0-.766-.146-1.06-.44a1.444 1.444 0 0 1-.44-1.06c0-.412.147-.765.44-1.059a1.45 1.45 0 0 1 1.06-.44c.412 0 .766.147 1.06.44.293.294.44.647.44 1.06 0 .412-.147.765-.44 1.06a1.45 1.45 0 0 1-1.06.44Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconMoreVertLine;
